import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";

// F5 · Slice de la vista Auditoría de empleados.
// El backend agrupa por category (order/payment/cash/...) y action (enum).
// Metadata es un JSON opaco con httpMethod/path/statusCode/durationMs/roleName/level.

const initialState = {
  isLoading: false,
  error: null,
  items: [],
  total: 0,
  query: {
    employeeId: null,
    action: null,
    category: null,
    from: null,
    to: null,
    page: 1,
    pageSize: 50,
  },
};

const slice = createSlice({
  name: "employeeAudit",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setPage(state, action) {
      state.isLoading = false;
      state.items = action.payload.items || [];
      state.total = action.payload.total || 0;
    },
    setQuery(state, action) {
      state.query = { ...state.query, ...action.payload };
    },
  },
});

export const { startLoading, hasError, setPage, setQuery } = slice.actions;
export default slice.reducer;

export function fetchAudit(overrides) {
  return async (dispatch, getState) => {
    const q = { ...getState().employeeAudit.query, ...(overrides || {}) };
    if (overrides) dispatch(setQuery(overrides));
    dispatch(startLoading());
    try {
      const res = await axios.post("employeeAudit/query", q);
      dispatch(setPage(res.data));
    } catch (err) {
      dispatch(hasError(err?.message || "Error consultando auditoría"));
    }
  };
}
